import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import getColor from "@insite/mobius/utilities/getColor";
import "@tSurya/theme";
import { css } from "styled-components";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

const stylesExtensions = require.context("./StylesExtensions", true);
stylesExtensions.keys().forEach(key => stylesExtensions(key));

const store = require.context("./Store", true);
store.keys().forEach(key => store(key));

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
//     // load all widget extensions. They could be loaded individually instead
//     const widgetExtensions = require.context("./WidgetExtensions", true);
//     widgetExtensions.keys().forEach(key => widgetExtensions(key));
// }
setPostStyleGuideTheme({
    // specifies primary colors are not editable & fixed to these values
    /* typography: {
        body: {
            fontFamily: "Mulish",
            css: css`
                font-size: 15px;
                font-weight: 400;
                line-height: 24px;
                color: #323132;
            `,
        },
        headerPrimary: {
            fontFamily: "Mulish",
            css: css`
                font-size: 15px;
                font-weight: 400;
                line-height: 22px;
                color: #323132;
            `,
        },
        headerSecondary: {
            fontFamily: "Mulish",
            css: css`
                font-size: 15px;
                font-weight: 400;
                line-height: 22px;
                color: #323132;
            `,
        },
        headerTertiary: {
            fontFamily: "Mulish",
            css: css`
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                color: #323132;
            `,
        },
        h1: {
            fontFamily: "Mulish",
            css: css`
                font-size: 28px;
                //font-weight: 400;
                line-height: 36px;
                color: #323132;
            `,
        },
        h2: {
            fontFamily: "Mulish",
            css: css`
                font-size: 26px;
                //font-weight: 400;
                line-height: 34px;
                color: #323132;
            `,
        },
        h3: {
            fontFamily: "Mulish",
            css: css`
                font-size: 24px;
                //font-weight: 400;
                line-height: 32px;
                color: #323132;
            `,
        },
        h4: {
            fontFamily: "Mulish",
            css: css`
                font-size: 20px;
                font-weight: 600;
                line-height: 28px;
                color: #323132;
            `,
        },
        h5: {
            fontFamily: "Mulish",
            css: css`
                font-size: 18px;
                font-weight: 600;
                line-height: 26px;
                color: #323132;
            `,
        },
        h6: {
            fontFamily: "Mulish",
            css: css`
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                color: #323132;
            `,
        },
        p: {
            fontFamily: "Mulish",
            css: css`
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                color: #323132;
            `,
        },
    }, */
    focus: {
        color: "#09f",
        style: "solid",
        width: "0px",
    },
    dataTable:{
        defaultProps: {
            cssOverrides: {
                table: css`
                    position: relative;
                `,
            },
        },
    },
    button: {
        primary: {
            css: css`
            height: 40px;
          `,
        },
        secondary: {
            css: css`
              height: 40px;
            `,
        },
       
    },
});
